import Component from '../abstracts/Component';
// quick refactoring of privacyComponent
export default class NewPrivacyKoreaComponent extends Component {

  static get SELECTORS() {
    return {
      Form: ".js-validate-form",
    };
  }

  // KR -------------------------

  krFormInputValidation() {
    const numRegex = new RegExp("^[a-zA-Z\u3131-\uD79D\\s]+$");
    const inputName = document.querySelectorAll('.js-kr-validation');
    let errSpan = '';

    inputName.forEach(input => {
      $(inputName).on('blur.input', (e) => {
        const inputVal = e.currentTarget.value;
        const clientErrorBox = e.currentTarget.nextSibling;
        if (numRegex.test(inputVal) && inputVal !== '') {
          e.currentTarget.classList.remove('error');
          clientErrorBox.classList.add('d-none');
        } else {
          e.currentTarget.classList.add('error');
          clientErrorBox.classList.remove('d-none');
          return false;
        }
      })
    });
  }

  //validation for emailDomain on KR registerForm
  krFormSelectInputValidation() {
    const numRegex = new RegExp("^[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$");
    const inputName = document.querySelectorAll('.js-kr-select-validation');
    let errSpan = '';

    inputName.forEach(input => {
      $(inputName).on('change.input', (e) => {
        const inputVal = e.currentTarget.value;
        const clientErrorBox = e.currentTarget.nextSibling.nextSibling;
        if (numRegex.test(inputVal) && inputVal !== '') {
          e.currentTarget.classList.remove('error');
          clientErrorBox.classList.add('d-none');
        } else {
          e.currentTarget.classList.add('error');
          clientErrorBox.classList.remove('d-none');
          return false;
        }
      })
    });

  }

  handleSubmitOnFormValidationError() {
    $('form').on('submit.sbmt', function(e) {
      const inputs = $(this).find('input');
      const validation = $(inputs).data('validation');
      if($(inputs).hasClass('error') && validation !== undefined && validation != '' && validation !== '') {
        e.preventDefault();
      }
    })
  }


  onSelectAllKr() {
    let allChk = false;
    let krCheckout = (document.body.classList.contains('t-checkout') && document.body.dataset.website === 'kr')

    $('body').on('change.krall','.js-kr-privacySelectAll', function (e) {
      e.stopImmediatePropagation();

      const $form = $(e.currentTarget).closest('form');
      const $container = $(e.currentTarget).closest('form').find('.js-privacy-kr')
      const $kr = $('.js-kr-selectable');

      if (!allChk) {
        $container.find('input[type="checkbox"]').prop('checked', true);
        $kr.removeClass('is-disabled');
        $form.find('.js-privacy-opts').removeClass('is-disabled');
        $container.find('input[type="radio"]').attr("disabled", false);
        // $form.find('button[type="submit"]').attr("disabled", false);

        if ( $('[name=newsletterProfiling]').is(':checked') && $('[name=newsletter]').is(':checked')) {
          $form.find('button[type="submit"]').attr("disabled", false);
        }

        if(krCheckout) {
          $form .find('.js-button-submit').removeClass("disabled");
        }

        allChk = true;
      } else {
        $container.find('input[type="checkbox"]').prop('checked', false);
        $kr.addClass('is-disabled');
        $form.find('.js-privacy-opts').addClass('is-disabled');
        $container.find('input[type="radio"]').attr("disabled", true);
        $form.find('button[type="submit"]').attr("disabled", true);

        if(krCheckout) {
          $form .find('.js-button-submit').removeClass("disabled");
        }

        allChk = false;
      }
    })

    $('body').on('change.kradioPrivacy', '[name="newsletterProfiling"], [name="newsletter"]', function (e) {
      e.stopImmediatePropagation();
      const $container = $(e.currentTarget).closest('form').find('.js-privacy-opts');
      const $form = $(e.currentTarget).closest('form');

      if ( $('[name=newsletterProfiling]').is(':checked') && $('[name=newsletter]').is(':checked')) {
        $form.find('button[type="submit"]').attr("disabled", false);
      }
    });
  }


  aknwloedgeKrPrivacy() {
    let ctx = this;
    let krCheckout = (document.body.classList.contains('t-checkout') && document.body.dataset.website === 'kr')
    let isKr = (document.body.dataset.website === 'kr');


      $('body').on('change.krreq', 'input[type="checkbox"]', function(e) {
        e.stopImmediatePropagation();
        let closestForm = $(e.currentTarget).closest('form');
        let button = '';
        let type = '';
        let requiredElements = closestForm.find('input.kr-mandatory');
        let isRequired = [];
        let chkRequired = [];


        for (let item of requiredElements) {
          isRequired.push(item);

          if($(item).is(':checked')) {
            chkRequired.push(item);
          }
        }

        switch(krCheckout) {
          case true:
            button = '.js-button-submit';
            type = 'fakeBtn';
            break;
          case false:
            button = 'button[type="submit"]';
            type = 'btn';
            break;
          default:
        }


        if( chkRequired.sort().toString() == isRequired.sort().toString()) {
          $('.js-privacy-kr').find('input[type="radio"]').attr("disabled", false);
          closestForm.find('.js-privacy-opts').removeClass('is-disabled');
          if(type === 'btn' ) {
            closestForm.find(button).attr("disabled", false);
          } else {
            closestForm.find(button).removeClass("disabled");
          }
        } else {
          $('.js-privacy-kr').find('input[type="radio"]').attr("disabled", true);
          closestForm.find('.js-privacy-opts').addClass('is-disabled');
          isRequired == []

          if(type === 'btn' ) {
            closestForm.find(button).attr("disabled", true);
          } else {
            closestForm.find(button).addClass("disabled");
          }
        }
      })

    // reset array
    $('body').on('change').on('change.reqall', '.js-kr-privacySelectAll', function(e) {
      chkRequired = [];
    })
  }

  animateOnSubmit(){
    this.$on('submit', ({event}) => {
      const button = $('#registerForm [type=submit]');
      this.$emit(this.$customEvents.LOADER_EVENTS.showLocal, {
        button: button,
        loadertype: button.data('loaderLocal')
      });
      
    }, '.js-validate-form')
  }


  render() {
    const isKr = document.querySelector('.js-kr-policy-container');
    super.render();

    if (isKr) {
      this.krFormInputValidation();
      this.krFormSelectInputValidation();
      this.onSelectAllKr();
      this.aknwloedgeKrPrivacy();
      this.handleSubmitOnFormValidationError();
      this.animateOnSubmit();
    }
  }

}
